import React, {createContext, useReducer} from "react";
import Reducer from './reducer'
import { ThemeProvider } from '@material-ui/core/styles';
import theme from '../theme';
import dark from '../theme/dark';
// eslint-disable-next-line no-use-before-define

const initialState = {
    post: {
        id: null,
        data: null,
        editmode: false,
    },
    login: {
        id: null,
        email: null,
        nama: null,
        chatname: null,
        akses: null,
        hak_akses: null,
        username: null,
        data: null
    },
    notif: [],
    subdata: [],
    outlet: [],
    owner: [],
    staff: [],
    tgl: [],
    transaksi: [],
    review: [],
    layanan: [],
    tanggal: [],
    page:{
        data:[],
        filter_tipe: false
    },
    jadwal:[],
    request:[],
    theme:[]
};

const Store = ({children}) => {
    const [state, dispatch] = useReducer(Reducer, initialState);
    var tema = localStorage.getItem('tema');
    var prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    if (tema != null) {
        state.theme = tema === 'true';
    } else {
        state.theme = prefersDark;
    }

    React.useEffect(() => {
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        const handleChange = (e) => {
            if (localStorage.getItem('tema') === null) {
                dispatch({
                    type: 'THEME',
                    content: e.matches
                });
            }
        };

        if (mediaQuery.addEventListener) {
            mediaQuery.addEventListener('change', handleChange);
        } else if (mediaQuery.addListener) {
            mediaQuery.addListener(handleChange);
        }

        return () => {
            if (mediaQuery.removeEventListener) {
                mediaQuery.removeEventListener('change', handleChange);
            } else if (mediaQuery.removeListener) {
                mediaQuery.removeListener(handleChange);
            }
        };
    }, [dispatch]);

    return (
         <ThemeProvider theme={state.theme === false ? theme : dark}>
        <Context.Provider value={[state, dispatch]}>
            {children}
        </Context.Provider>
        </ThemeProvider>
    )
};

export const Context = createContext(initialState);
export default Store;